import firebase from 'firebase'
import 'firebase/firestore'
import {judge_is_valid_list} from './mylist_util_helper'


export const get_userinfo_create_follow_list = async (firebase_uid) => {
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  const doc = await user_db.get()
  const user_info = doc.data()
  const create_lists = ('create_list' in user_info) ? user_info.create_list : []
  const follow_lists = ('follow_list' in user_info) ? user_info.follow_list : []
  return {create_lists, follow_lists}
}


export const update_userinfo_create_list = async (firebase_uid, update_list) => {
  if(judge_is_valid_list(update_list) == false){
    return false
  }
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  await user_db.update({ create_list: update_list })
  return true
}


export const update_userinfo_follow_list = async (firebase_uid, update_list) => {
  if(judge_is_valid_list(update_list) == false){
    return false
  }
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  await user_db.update({ follow_list: update_list })
  return true
}


export const update_userinfo_follow_users = async (firebase_uid, follow_user_list) => {
  const db = firebase.firestore()
  const user_db = db.collection("users").doc(firebase_uid)
  await user_db.update({ follow_users: follow_user_list })
  return true
}